"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDrawingTools = exports.RESTRICTION_TYPE = exports.AxisRestrictionApi = exports.GeometryRestrictionApi = exports.AngularRestrictionApi = exports.GridRestrictionApi = exports.PlaneRestrictionApi = exports.DrawingToolsApi = void 0;
const AngularRestrictionApi_1 = require("./api/implementation/restrictions/plane/snap/AngularRestrictionApi");
Object.defineProperty(exports, "AngularRestrictionApi", { enumerable: true, get: function () { return AngularRestrictionApi_1.AngularRestrictionApi; } });
const AxisRestrictionApi_1 = require("./api/implementation/restrictions/plane/snap/AxisRestrictionApi");
Object.defineProperty(exports, "AxisRestrictionApi", { enumerable: true, get: function () { return AxisRestrictionApi_1.AxisRestrictionApi; } });
const DrawingToolsApi_1 = require("./api/implementation/DrawingToolsApi");
Object.defineProperty(exports, "DrawingToolsApi", { enumerable: true, get: function () { return DrawingToolsApi_1.DrawingToolsApi; } });
const GeometryRestrictionApi_1 = require("./api/implementation/restrictions/geometry/GeometryRestrictionApi");
Object.defineProperty(exports, "GeometryRestrictionApi", { enumerable: true, get: function () { return GeometryRestrictionApi_1.GeometryRestrictionApi; } });
const GridRestrictionApi_1 = require("./api/implementation/restrictions/plane/snap/GridRestrictionApi");
Object.defineProperty(exports, "GridRestrictionApi", { enumerable: true, get: function () { return GridRestrictionApi_1.GridRestrictionApi; } });
const viewer_1 = require("@shapediver/viewer");
const IRestriction_1 = require("./business/interfaces/IRestriction");
Object.defineProperty(exports, "RESTRICTION_TYPE", { enumerable: true, get: function () { return IRestriction_1.RESTRICTION_TYPE; } });
const PlaneRestrictionApi_1 = require("./api/implementation/restrictions/plane/PlaneRestrictionApi");
Object.defineProperty(exports, "PlaneRestrictionApi", { enumerable: true, get: function () { return PlaneRestrictionApi_1.PlaneRestrictionApi; } });
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const defaultTextures = {};
defaultTextures['variation_0'] = viewer_1.MaterialEngine.instance.loadMap('https://viewer.shapediver.com/v3/graphics/point_soft.png')
    .then((mapData) => {
    defaultTextures['variation_0'] = mapData;
    return mapData;
});
let drawingTools;
/**
 * Create a new instance of DrawingTools.
 *
 * @param viewport The viewport to which the DrawingTools should be attached.
 * @param callback The callback function that is called when the drawing is finished.
 * @param properties The customization properties for the DrawingTools.
 * @returns The DrawingTools instance.
 * @throws An error if there is already an active instance of DrawingTools.
 */
const createDrawingTools = (viewport, callbacks, settings) => {
    if (viewer_shared_services_1.SystemInfo.instance.isMobile)
        throw new viewer_1.ShapeDiverViewerDrawingToolsError('The DrawingTools are not supported on mobile devices.');
    if (drawingTools && drawingTools.closed === false)
        throw new viewer_1.ShapeDiverViewerDrawingToolsError('There can only be one instance of DrawingTools active at a time. Please close the current instance before creating a new one.');
    drawingTools = new DrawingToolsApi_1.DrawingToolsApi(viewport, callbacks, settings, defaultTextures);
    return drawingTools;
};
exports.createDrawingTools = createDrawingTools;
//# sourceMappingURL=index.js.map